import { useState, useRef } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";

type TextInputProps = Omit<TextFieldProps, 'onChange' | 'value'> & {
  initialValue: string;
  onChange: (value: string) => void;
  debounceMs?: number;
};

export const TextInput = ({ initialValue, onChange, debounceMs = 500, ...props }: TextInputProps) => {
  const [localValue, setLocalValue] = useState(initialValue);
  const [localSourceValue, setLocalSourceValue] = useState(initialValue);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const displayedValue = localSourceValue === initialValue ? localValue : initialValue;

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    setLocalSourceValue(initialValue);
    setLocalValue(event.target.value);

    timerRef.current = setTimeout(() => {
      onChange(event.target.value);
    }, debounceMs);
  }

  return (
    <TextField
      {...props}
      value={displayedValue}
      onChange={handleChange}
    />
  );
};
